import { createFileRoute } from '@tanstack/react-router';
import { useTranslations } from 'use-intl';
import {
  Header,
  HeaderButton,
  HeaderCopyButton,
  HeaderOrganizationMenu,
  HeaderSidebarTrigger,
} from '@/app/ui/components/header';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
} from '@/app/ui/components/breadcrumb';
import { MainScrollArea } from '@/app/ui/components/main';
import { HugeiconsIcon } from '@hugeicons/react';
import { UserGroupIcon, PlusSignIcon } from '@hugeicons/core-free-icons';
import { use } from 'react';
import { AppContext } from '@/app/appContext';
import OrganizationMembersList from '@/app/components/features/organizations/OrganizationMembersList';
import { OrganisationUserRoles } from '@/app/utils/constants';
import { inviteOrgMemberOpenAtom } from '@/app/components/features/organizations/store';
import { useSetAtom } from 'jotai';

export const Route = createFileRoute('/_authed/(organization)/_layout/members')({
  component: RouteComponent,
});

function RouteComponent() {
  const t = useTranslations();
  const { userMeta } = use(AppContext);
  const isAdmin = userMeta?.organizationRole === OrganisationUserRoles.ADMIN;
  const setInviteDialogOpen = useSetAtom(inviteOrgMemberOpenAtom);

  return (
    <>
      <Header>
        <HeaderOrganizationMenu />
        <HeaderSidebarTrigger />
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbPage>
                <HugeiconsIcon icon={UserGroupIcon} />
                {t('pages.teamMembers.title')}
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
        {isAdmin && (
          <HeaderButton
            aria-label={t('pages.organizationMembers.inviteButton')}
            onClick={() => setInviteDialogOpen(true)}
          >
            <HugeiconsIcon icon={PlusSignIcon} />
          </HeaderButton>
        )}
        <HeaderCopyButton />
      </Header>
      <MainScrollArea>
        <OrganizationMembersList />
      </MainScrollArea>
    </>
  );
}
